import type { Airflow } from '@aviata/platform-types';

import { api } from '@/shared/api';

const savePassengers = (
  offerId: string,
  passengers: Airflow.Order.Payload.Entity['passengers'],
): Promise<Airflow.Order.Entity> =>
  api.airflow.savePassengers(offerId, passengers).then(({ data }) => data);

export const savePassengersApi = {
  savePassengers,
};
